import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import VALUTA_REGEX from '../../../validators/regex/valuta.regex';
import {AccountCategoryService} from '../../../services/account-category.service';
import {AccountService} from '../../../services/account.service';
import {AccountCategoryDTO} from '../../../model/accountCategoryDTO';
import {ValidateAccountNumber} from '../../../validators/iban.validator';
import {ReportService} from '../../../services/report.service';
import {StartDateDTO} from '../../../model/startDateDTO';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmAddSupportedBankDialogComponent} from './confirm-add-supported-bank-dialog/confirm-add-supported-bank-dialog.component';
import {Location} from '@angular/common';
import {NotificationService} from '../../../services/notification.service';
import {AddManualAccountDTO} from '../../../model/addManualAccountDTO';


@Component({
  templateUrl: './add-manual-account.component.html',
  styleUrls: ['./add-manual-account.component.scss']
})
export class AddManualAccountComponent implements OnInit {

  startDate: StartDateDTO;
  accountCategories: Array<AccountCategoryDTO>;
  submitted = false;
  loading = false;
  public formGroup: FormGroup;
  private clientId: number;
  private banks = {RABO: 'Rabobank', INGB: 'ING', ABNA: 'Abn Amro'};

  constructor(private accountCategoryService: AccountCategoryService,
              private router: Router,
              private notificationService: NotificationService,
              private location: Location,
              private route: ActivatedRoute,
              private reportService: ReportService,
              private service: AccountService,
              private dialog: MatDialog,
              private formBuilder: FormBuilder) {
  }

  get f() {
    return this.formGroup.controls;
  }

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.clientId = data['clientId'];
      this.formGroup = this.getFormGroup();
      this.accountCategoryService.get()
        .subscribe(accountCategories => this.accountCategories = accountCategories);
      this.reportService.getNextReportStartDate(this.clientId)
        .subscribe(startDate => this.startDate = startDate);
    });
  }

  submit() {
    this.submitted = true;
    if (this.formGroup.valid && !this.loading) {
      this.loading = true;
      const selectedBank = this.getChosenBankSupported(this.formGroup.get('accountNumber').value);
      if (selectedBank !== null) {
        this.confirmAddSupportedBank(selectedBank)
          .then(() => this.save(this.mapToDto()))
          .finally(() => this.loading = false);
      } else {
        this.save(this.mapToDto());
      }
    }
  }

  back() {
    this.location.back();
  }

  /** returns null */
  private getChosenBankSupported(value: any): string {
    for (const bankCode of Object.keys(this.banks)) {
      if (value.toUpperCase().indexOf(bankCode) !== -1) {
        return this.banks[bankCode];
      }
    }
    return null;
  }

  private getFormGroup(): FormGroup {
    return this.formBuilder.group({
      accountNumber: ['', [Validators.required, ValidateAccountNumber]],
      accountCategoryId: [null, [Validators.required]],
      openingBalance: ['', [Validators.required, Validators.pattern(VALUTA_REGEX)]],
    });
  }

  private async confirmAddSupportedBank(bank: string): Promise<void> {
    const data = {clientId: this.clientId, bank: bank};
    return this.dialog.open(ConfirmAddSupportedBankDialogComponent, {data: data, width: '1175px'}).componentInstance.promise();
  }

  private save(dto: AddManualAccountDTO) {
    this.service.addManual(dto).subscribe(
      (account) => {
        this.notificationService.success('rekening toegevoegd');
        this.router.navigate([`/rekening/${account.id}/handmatig-transacties-toevoegen`]);
      },
      (response) => this.notificationService.errorResponse(response),
      () => this.loading = false
    );
  }

  private mapToDto(): AddManualAccountDTO {
    const value = this.formGroup.value;
    return {
      clientId: this.clientId,
      startDate: this.startDate.value,
      accountNumber: value.accountNumber,
      accountCategoryId: value.accountCategoryId,
      openingBalance: value.openingBalance
    };
  }

}
